import RestClient from './RestClient';
import SioBridge from '../SioBridge';
import _ from 'lodash';

class Devices extends RestClient {
    constructor(config) {
        if (!config?.model || !config?.resource || !config?.resources)
            throw new Error('Can not instantiate generic device.');
        super(config);
    }

    list() {
        // by sending all_xxx instead of xxx, we are
        // asking even the disconnected devices
        return SioBridge.sendMessage(`all_${this.resources}`)
            .then(devices => {
                if (Array.isArray(devices)) {
                    devices = devices.map(c => new this.model(c));

                    if (this.sortBy)
                        devices = _.sortBy(devices, this.sortBy);

                    return { [this.resources]: devices };
                }

                throw new Error();
            });
    }

    get(id) {
        return SioBridge.sendMessage(this.resource, { id })
            .then(device => {
                if (device) {
                    device = new this.model(device);

                    return { [this.resource]: device };
                }

                throw new Error();
            }).catch(error => {
                throw new Error(error);
            });
    }

    update(device) {
        const { _id, options } = device;
        return SioBridge.sendMessage(`save_${this.resource}_options`, { _id, options })
            .then(device => {
                if (device) {
                    device = new this.model(device);

                    return { [this.resource]: device };
                }

                throw new Error();
            }).catch(error => {
                throw new Error(error);
            });
    }

    forget(device) {
        const { _id, type } = device;
        return SioBridge.sendMessage('forget_device', { _id, type })
            .then(result => {
                return result;
            }).catch(error => {
                throw new Error(error);
            });
    }

    runAction(id, action, params) {
        return SioBridge.sendMessage(`${this.resource}_action`, { [`${this.resource}Id`] : id, action, params })
            .then(result => {
                if (result.error)
                    throw new Error(result.error);

                return result;
            }).catch(error => {
                throw new Error(error);
            });
    }
}

export default Devices;
